<template>
    <b-container class="Footer wrapper" :class="displayFooter">
        <b-row>
            <b-col md="3" sm="12">
                <img src="../assets/favicon_ijl.png" alt="it Jonction">
                <p class="footerP">{{$t('footer')}}</p>
            </b-col>

            <b-col class="footerFlex" md="9" sm="12">
                <div class="footerLinks">
                    <div @click="footerRedirect('/')" class="footerLink">Home</div>
                    <div @click="footerRedirect('/process')" class="footerLink">{{$t('link1')}}</div>
                    <div @click="footerRedirect('/tech')" class="footerLink">{{$t('link2')}}</div>
                    <DiscussBtn />
                </div>
                <div class="footerFoot">
                    <ParisLove />
                    <!-- <img src="../assets/cookedInParis.png" alt="From Paris with Love"> -->
                    <p class="footerRights">© {{ new Date().getFullYear() }} IT Jonction Lab | All Rights Reserved</p>
                </div>
            </b-col>
        </b-row>
    </b-container >
</template>

<script>
import DiscussBtn from "./DiscussBtn.vue"
import ParisLove from "./ParisLove.vue"

export default {
    name:'Footer',
    components: {
        DiscussBtn,
        ParisLove
    },
    computed: {
        displayFooter: function () {
            if(window.innerWidth<=768) {
                return 'dn'
            } else {
                return 'footer-bloc'
            }
        }
    },
    methods: {
        footerRedirect: function(pathTo) {
            this.$router.push({ path: pathTo })
            window.scrollTo(0,0)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/footer.scss';
</style>
